import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo_sq from '../../assets/images/logo-sq.jpg'
import { Link } from "react-router-dom";

function About() {
    return ( 
        <div className="container-fluid py-5 wow fadeInUp" id="about" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="row g-5">
                    <div className="col-lg-7">
                        <div className="section-title position-relative pb-3 mb-5">
                            <h5 className="fw-bold text-danger">سایت مرجع GREhub</h5>
                            <h1 className="mb-0">شبیه ساز حرفه ای آزمون های بین المللی GRE</h1>
                        </div>
                        <p className="mb-4">
                            سایت <b>GREhub</b> با این هدف راه اندازی شده که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل <b>کراون</b> Crown، <b>دالائو</b> Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی <b>بهترین نمره</b> را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید.
                            <br /><br />
                            از دیگر امکانات وبسایت مرجع GREhub به اشتراک گذاشتن برترین و آخرین منابع، مصاحبه ها، تجربه ها، کدهای تخفیف ets و به عنوان هاب GRE هر آن‌چه مرتبط با موفقیت در آزمون جی آر ای هست به طور یکجا، برای شماست.
                        </p>
                        <div className="row g-0 mb-3">
                            <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                                <h5 className="mb-3"><FontAwesomeIcon icon="check" className="text-success me-3"/>ترجمه همزمان</h5>
                                <h5 className="mb-3"><FontAwesomeIcon icon="check" className="text-success me-3"/>به روزترین منابع</h5>
                            </div>
                            <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                                <h5 className="mb-3"><FontAwesomeIcon icon="check" className="text-success me-3"/>درگاه بین المللی</h5>
                                <h5 className="mb-3"><FontAwesomeIcon icon="check" className="text-success me-3"/>پشتیبانی ۲۴ ساعته</h5>
                            </div>
                        </div>
                        <Link to="/login" className="btn btn-danger py-3 px-5 mt-3 wow zoomIn" data-wow-delay="0.9s">همین حالا رایگان آزمون دهید!</Link>
                    </div>
                    <div className="col-lg-5" style={{minHeight: "500px"}}>
                        <div className="position-relative h-100 shadow bg-body-tertiary">
                            <img className="position-absolute w-100 h-100 rounded wow zoomIn" alt="about" data-wow-delay="0.9s" src={logo_sq} style={{objectFit: "cover"}} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default About;